import Vue from 'vue';
import Router from 'vue-router';
import Home from './components/Home.vue';
import PrivacyPolicy from './components/PrivacyPolicy.vue';
import TermsOfService from './components/TermsOfService.vue';
import DataDeletion from './components/DataDeletion.vue';
import Pricing from './components/Pricing.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    { path: '/', name: 'Home', component: Home },
    { path: '/privacy-policy', name: 'PrivacyPolicy', component: PrivacyPolicy },
    { path: '/terms-of-service', name: 'TermsOfService', component: TermsOfService },
    { path: '/data-deletion', name: 'DataDeletion', component: DataDeletion },
    { path: '/pricing', name: 'Pricing', component: Pricing }
  ]
}); 